export const CURRENT_USER_QUERY_KEY = "user::current"
export const CURRENT_USER_ENDPOINT = "/api/users/v1/current_user"

export const CURRENT_USER_SEARCH_CONFIG_QUERY_KEY = "user::current::searchConfig"
export const CURRENT_USER_SEARCH_CONFIG_ENDPOINT = "/v1alpha1/search-config/user-search-config"

export const CURRENT_USER_SEARCH_CRITERIA_QUERY_KEY = "user::current::searchCriteria"
export const CURRENT_USER_SEARCH_CRITERIA_ENDPOINT = "/student_profiles/v2/search_criteria"
